import { render } from "./PresenceManagmentPage.vue?vue&type=template&id=e9619656&scoped=true"
import script from "./PresenceManagmentPage.vue?vue&type=script&lang=js"
export * from "./PresenceManagmentPage.vue?vue&type=script&lang=js"

import "./PresenceManagmentPage.vue?vue&type=style&index=0&id=e9619656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9619656"]])

export default __exports__